import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import AddNotAcceptedComment from '../../../widgets/notAcceptedComment/notAcceptedComment'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getReviewSend } from '../../../redux/actions/reviewSend'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ReviewSend from '../../../widgets/reviewSend/ReviewSend'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'

export default function ReviewSendPage() {
  const [isEditAll, setIsEditAll] = useState(false)
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getReviewSend(projectId)
      setSchema(_schema.model)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    projectId && handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <ProjectBasicInfo schema={schema?.forms?.ProjectInfo} />

          <br />

          <ReviewSend schema={schema?.forms?.ReviewForm} />
        </SidebarProposal>
      )}
    </>
  )
}
